/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable max-lines */
/* eslint-disable no-redeclare */
/* eslint-disable complexity */
const { inject, observer } = require('mobx-react');
const React = require('react');

const { ErrorBoundary, ViewExtraLarge, ViewLarge, ViewMedium, Viewport, ViewSmall } = require('bernie-view');
const { QueryRoute } = require('bernie-core');
const { withLocalization } = require('bernie-l10n');

const { CustomerNotificationLocation } = require('@shared-ui/customer-notifications');
const { VirtualAgentControl } = require('@shared-ui/customer-virtual-agent-control');

const { MitStep } = require('models/multi-item/multi-item-types');
const { SearchPageName } = require('constants/pages');

const { classNames } = require('uitk-react-utils');
const { Level, liveAnnounce } = require('uitk-react-utils');
const { UitkEmptyState } = require('uitk-react-empty-state');
const { UitkLayoutGrid, UitkLayoutGridItem } = require('uitk-react-layout-grid');
const { UitkSpacing } = require('uitk-react-spacing');

const { CustomerNotifications } = require('components/common/customer-notifications');
const { DelayedSortAndFilterFetchExperiment } = require('components/search/experiments/delayed-sort-and-filter-experiment');
const { ExitIntent } = require('components/search/exit-intent');
const { LoyaltyEducationDialog } = require('components/common/loyalty-education/loyalty-education-dialog');
const { MainRegion } = require('components/layout/pages/main-region');
const { MasterPage } = require('components/layout/pages/master-page');
const { MesoFooter } = require('components/meso/meso-footer');
const { MesoSideRail } = require('components/meso/meso-side-rail');
const { MitHeader } = require('components/multi-item/multi-item-header');
const { MultiItem } = require('components/multi-item');
const { Playback } = require('components/search/playback/playback');
const { PropertySearchListings } = require('components/search/property-search-listings');
const { ResultsHeader } = require('components/search/results-header.tsx');
const { RewardsEducationDialog } = require('components/common/rewards-education-dialog');
const { Sidebar } = require('components/search/sidebar.tsx');
const { SideRailRegion } = require('components/layout/pages/side-rail-region');
const { ToolbarRegion } = require('components/layout/pages/toolbar-region');
const ViewportListener = require('components/common/lazy/viewport-listener.js');

const MasterPageToolbarTypes = MasterPage.wrappedComponent.toolbarTypes;
const MasterPageSideRailTypes = MasterPage.wrappedComponent.sideRailTypes;

const RENDER_REMAINING_AFTER_INDEX = 10;
const FETCH_ON_SCROLL_INDEX = 25;

@withLocalization
@inject(
  'advertising',
  'analytics',
  'context',
  'experiment',
  'multiItem',
  'page',
  'routeStore',
  'searchResults',
  'uiPage',
  'virtualAgentControlStore'
)
@observer
class Search extends React.Component {
  resultRefs = [];
  fetchOnScrollCalled = false;
  queueShowMore = false;

  constructor(props) {
    super(props);

    this.handleOnDismiss = this.handleOnDismiss.bind(this);
    this.handleRetry = this.handleRetry.bind(this);
    this.handleShowMore = this.handleShowMore.bind(this);
    this.markUsable = this.markUsable.bind(this);
    this.setResultRef = this.setResultRef.bind(this);
    this.fetchOnScroll = this.fetchOnScroll.bind(this);

    this.state = {
      jsEnabled: false,
      fetchOnScrollResolved: false,
    };

    if (
      this.props.searchResults &&
      this.props.searchResults.searchCriteria &&
      this.props.searchResults.searchCriteria.multiProp === 'true'
    ) {
      this.props.multiItem && this.props.multiItem.getOrCreateCart(this.props.context);
    }

    if (this.props.multiItem?.multiItemContext) {
      this.props.advertising?.trigger(SearchPageName[this.props.multiItem.multiItemContext.packageType]);
    } else {
      this.props.advertising?.trigger('page.Hotels.Search');
    }
  }

  get backToChangeSearchQuery() {
    const { routeStore } = this.props;
    if (routeStore && typeof routeStore.mergeQueryString === 'function') {
      return routeStore.mergeQueryString(routeStore.search, { pwaOverlay: 'changeSearch' });
    }
  }

  get loading() {
    const { searchResults, uiPage } = this.props;

    return searchResults.isLoading && !uiPage.displayProgressIndicator;
  }

  markUsable(usable, pageUsableMarked) {
    const { analytics, searchResults } = this.props;

    if (usable && !pageUsableMarked) {
      analytics.markPageUsable();

      searchResults.pageUsableMarked = true;
    }
  }

  componentDidMount() {
    const { usable, pageUsableMarked } = this.props.searchResults;

    this.markUsable(usable, pageUsableMarked);

    this.announceLoadingState();
    this.trackDisambiguationSearch();
    this.trackSearchResultsError();

    this.setState({ jsEnabled: true });
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { usable, pageUsableMarked } = nextProps.searchResults;

    // This if statement exists to get around a unit test case for re-rendering.
    if (this.markUsable) {
      this.markUsable(usable, pageUsableMarked);
    }

    // This happens once in componentDidMount and should not require the entire component tree to rerender
    const jsEnabledChanged = this.state.jsEnabled !== nextState.jsEnabled;

    // This should be fixed in the LocationReactor component in bernie
    const locationSetForTheFirstTime = this.props.location === undefined && typeof nextProps?.location === 'object';

    // If either of the conditions are true then we will prevent the rerender, setting shouldRerender to false
    const shouldRerender = !(jsEnabledChanged || locationSetForTheFirstTime);

    return shouldRerender;
  }

  trackDisambiguationSearch() {
    if (this.props.multiItem && this.props.multiItem.isDisambigSearch()) {
      if (this.props.analytics && typeof this.props.analytics.trackEvent === 'function') {
        const events = [{ name: 'SearchResultsDisambig', error: false }];
        this.props.analytics.trackEvent(this.props.multiItem.referrer, 'package disambig search', null, events);
      }
    }
  }

  trackSearchResultsError() {
    const { isEmpty, isError } = this.props.searchResults;

    if (isEmpty || isError) {
      if (this.props.analytics && typeof this.props.analytics.trackEvent === 'function') {
        this.props.analytics.trackEvent('SorryMessage', 'SorryMessage', null);
      }
    }
  }

  componentDidUpdate() {
    this.announceLoadingState();
  }

  announceLoadingState() {
    const { isLoading, isError, isEmpty } = this.props.searchResults;
    const { l10n } = this.props;

    let message;
    if (isLoading) {
      message = l10n.formatText('hotels.searchResults.resultsLoading.liveAnnounce');
    } else if (isError) {
      message = l10n.formatText('hotels.searchResults.errorRetrievingResults.liveAnnounce');
    } else if (isEmpty) {
      message = l10n.formatText('hotels.searchResults.emptyResults.liveAnnounce');
    } else {
      message = l10n.formatText('hotels.searchResults.resultsUpdated.liveAnnounce');
    }
    if (message !== this.lastLoadingStateMessage) {
      liveAnnounce(message, Level.POLITE);
      this.lastLoadingStateMessage = message;
    }
  }

  handleOnDismiss() {
    const { routeStore } = this.props;
    if (routeStore && typeof routeStore.goBack === 'function') {
      routeStore.goBack();
    }
  }

  setResultRef(ref, index) {
    if (ref === null || this.resultRefs[index] === ref) {
      return;
    }

    this.resultRefs[index] = ref;

    if (index === RENDER_REMAINING_AFTER_INDEX) {
      ViewportListener.subscribe(
        'window',
        ref,
        {
          didEnter: () => this.props.searchResults.setHotelsMaxDisplayToTotalRenderCount(),
          isAbove: () => this.props.searchResults.setHotelsMaxDisplayToTotalRenderCount(),
        },
        { extendBoundingBoxToBottomOfPage: true, triggerOnce: true }
      );
    } else if (this.props.searchResults.isReducedPayloadExperimentV1 && index === FETCH_ON_SCROLL_INDEX) {
      this.fetchOnScrollCalled = false;
      ViewportListener.subscribe(
        'window',
        ref,
        {
          didEnter: () => this.fetchOnScroll(),
          isAbove: () => this.fetchOnScroll(),
        },
        { extendBoundingBoxToBottomOfPage: true, triggerOnce: true }
      );
    }
  }

  render() {
    const { context, experiment, analytics, page, l10n, searchResults, multiItem, virtualAgentControlStore } = this.props;

    const searchCriteria = searchResults?.searchCriteria;
    const regionId = searchCriteria?.regionId;
    const startDate = searchCriteria?.startDate;
    const endDate = searchCriteria?.endDate;

    const rewardsEducation = searchResults && searchResults.rewardsDialogContent && searchResults.rewardsDialogContent.rewardsEducation;
    const loyaltyEducation = searchResults && searchResults.loyaltyEducation;
    const isMixMatchCart = multiItem && multiItem.cartInfo && multiItem.cartInfo.identifier === 'mixAndMatch';
    const masterPageClasses = classNames('search-results');
    const pageName = page?.pageName || SearchPageName.SA;

    if (isMixMatchCart && multiItem.itemCount > 0) {
      multiItem.emptyCart(context);
    }

    return (
      <MasterPage
        className={masterPageClasses}
        loading={this.loading}
        route={this.props.route}
        searchCriteria={searchResults.searchCriteria}
        navigationTabs={searchResults.navigationTabs}
        sideRailType={MasterPageSideRailTypes.NEXT_TO_MAIN_AND_TOOLBAR}
        toolbarType={MasterPageToolbarTypes.NORMAL}
        pageHeader={searchResults.resultsHeading}
      >
        <ToolbarRegion className="search-results-toolbar">
          <Playback
            bookingNextProperty={multiItem && multiItem.isTouchedCart && !multiItem.isPackageShoppingPath()}
            shouldShowMultiItemWizardFields={multiItem && multiItem.isPackageShoppingPath()}
            packageType={multiItem && multiItem.getPackageType()}
          />
        </ToolbarRegion>
        <MainRegion className="search-results__main s-x-margin-two">
          <MitHeader {...{ l10n, multiItem, currentStepName: MitStep.HOTEL, page, context, experiment }} />
          <CustomerNotifications
            location={CustomerNotificationLocation.AFTER_HEADER}
            regionId={regionId}
            startDate={startDate}
            endDate={endDate}
          />
          <UitkSpacing padding={{ small: { block: 'three' }, medium: { blockstart: 'one' }, large: { blockstart: 'three' } }}>
            <div className="search-results-listing">
              <Viewport>
                <ViewSmall>
                  <ErrorBoundaryWrappedTools analytics={analytics} />
                  {this.renderResults()}
                </ViewSmall>
                <ViewMedium>
                  <ErrorBoundaryWrappedTools analytics={analytics} />
                  {this.renderResults()}
                </ViewMedium>
                <ViewLarge>
                  <LargeSearchResults jsEnabled={this.state.jsEnabled} results={this.renderResults()} showTools={true} />
                </ViewLarge>
                <ViewExtraLarge>
                  <ExtraLargeSearchResults
                    context={context}
                    analytics={analytics}
                    jsEnabled={this.state.jsEnabled}
                    results={this.renderResults()}
                    showTools={true}
                    searchResults={searchResults}
                  />
                </ViewExtraLarge>
              </Viewport>
            </div>
          </UitkSpacing>

          <CustomerNotifications location={CustomerNotificationLocation.FOOTER} regionId={regionId} />

          <QueryRoute query={{ pwaDialog: 'rewardsEducation' }}>
            <RewardsEducationDialog rewardsEducation={rewardsEducation} />
          </QueryRoute>
          <QueryRoute query={{ pwaDialog: 'loyaltyEducation' }}>
            <LoyaltyEducationDialog loyaltyEducation={loyaltyEducation} />
          </QueryRoute>
          {searchResults.exitIntent && multiItem && !multiItem.isPackageShoppingPath() && (
            <ErrorBoundary label="hotel.search.exitIntent">
              <ExitIntent showOnce={true} exitIntent={searchResults.exitIntent} />
            </ErrorBoundary>
          )}
          {multiItem && !multiItem.isPackageShoppingPath() && <MultiItem analytics={analytics} pageName={pageName} />}
          {virtualAgentControlStore.shouldInjectChatbot(context, page, experiment) && (
            <VirtualAgentControl
              applicationName="shopping-pwa"
              pageName={pageName}
              clientOverrides={{
                subscribedEvents: [virtualAgentControlStore.VAC_WIDGET_OPENED_EVENT, virtualAgentControlStore.VAC_WIDGET_CLOSED_EVENT],
                eventHandler: event => virtualAgentControlStore.eventHandler(analytics, event),
              }}
            />
          )}
          <DelayedSortAndFilterFetchExperiment />
        </MainRegion>
        <SideRailRegion>
          <MesoSideRail pageName={pageName} />
        </SideRailRegion>
      </MasterPage>
    );
  }

  renderResults() {
    const { legalDisclaimer } = this.props.searchResults;
    const { l10n, page } = this.props;
    const pageName = page?.pageName || SearchPageName.SA;

    return (
      <>
        <h2 className="is-visually-hidden">{l10n.formatText('hotels.search.results.heading')}</h2>
        <PropertySearchListings
          setResultRef={this.setResultRef}
          showMoreLabel={l10n.formatText('hotels.searchResults.paginationButton.label')}
          handleShowMore={this.handleShowMore}
          fetchOnScrollResolved={this.state.fetchOnScrollResolved}
        />
        {this.renderErrorMessage()}
        <MesoFooter pageName={pageName} />
        {legalDisclaimer?.content && (
          <UitkSpacing padding={{ block: 'six' }}>
            <p
              dangerouslySetInnerHTML={{
                __html: legalDisclaimer?.content
                  .filter(content => content.markupType === 'HTML')
                  .map(content => content.text)
                  .join('<br/><br/>'),
              }}
            />
          </UitkSpacing>
        )}
      </>
    );
  }

  refreshAds() {
    if (document && CustomEvent && typeof document.dispatchEvent === 'function') {
      document.dispatchEvent(new CustomEvent('mesoTriggeredRefresh', { detail: { type: 'impressionRefresh' } }));
    }
  }

  showMoreHotels() {
    const { analytics, context, multiItem, searchResults, experiment } = this.props;
    this.props.uiPage.showProgressIndicator(400);

    searchResults.showMoreHotels(analytics, context, multiItem, experiment).then(previousMax => {
      // Move focus to the first newly revealed HSR cards, for better screen reader experience.
      this.resultRefs[previousMax].focus();
    });
  }

  fetchOnScroll() {
    if (!this.fetchOnScrollCalled) {
      const { analytics, context, multiItem, searchResults, experiment } = this.props;
      this.fetchOnScrollCalled = true;
      searchResults.showMoreHotels(analytics, context, multiItem, experiment).then(() => {
        this.setState(
          {
            fetchOnScrollResolved: true,
          },
          () => {
            if (this.queueShowMore) {
              this.handleShowMore();
            }
          }
        );
      });
    }
  }

  handleShowMore() {
    const { isReducedPayloadExperimentV1 } = this.props.searchResults;

    if (!isReducedPayloadExperimentV1 || this.state.fetchOnScrollResolved) {
      this.refreshAds();
      this.showMoreHotels();
    } else {
      this.props.uiPage.showProgressIndicator();
      this.queueShowMore = true;
    }
  }

  handleRetry(rfrr, message) {
    const { routeStore, searchResults, analytics } = this.props;

    if (rfrr && message && analytics && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent(rfrr, message, null, null, true);
    }

    if (routeStore) {
      searchResults.shouldFetch = true;
      routeStore.updateSearch(routeStore.search);
    } else {
      window.location.reload();
    }
  }

  renderErrorMessage() {
    const searchResults = this.props.searchResults || {};
    const { isError, isEmpty, searchCriteria, errorResponse } = searchResults;
    const { l10n } = this.props;

    const multiItem = searchCriteria && searchCriteria.misId;

    if (isError || isEmpty) {
      if (multiItem) {
        if (errorResponse) {
          return (
            <UitkSpacing padding={{ blockstart: 'six', blockend: 'twelve' }}>
              <div className="uitk-type-center">
                <UitkEmptyState
                  icon="search"
                  heading={errorResponse.header}
                  body={errorResponse.body}
                  buttonText={errorResponse.button.primary}
                  headingLevel="h2"
                  onClick={() => this.handleLinkActionFromErrorMessage(errorResponse.button.action)}
                  className="all-t-padding-three multi-item-retry-search"
                />
              </div>
            </UitkSpacing>
          );
        }
        const headingText = l10n.formatText('multiItem.searchResults.error.text');
        const bodyText = l10n.formatText('multiItem.searchResults.tryAgain.text');
        const buttonText = l10n.formatText('multiItem.searchResults.retryButton.label');

        return (
          <UitkSpacing padding={{ blockstart: 'six', blockend: 'twelve' }}>
            <div className="uitk-type-center">
              <UitkEmptyState
                icon="search"
                heading={headingText}
                body={bodyText}
                buttonText={buttonText}
                headingLevel="h2"
                onClick={() => this.handleRetry(':errorOnSearch', 'MultiItem Retry Search')}
                className="all-t-padding-three multi-item-retry-search"
              />
            </div>
          </UitkSpacing>
        );
      }
      const errorMessage =
        !isError && isEmpty
          ? l10n.formatText('hotels.searchResults.emptyResults.text')
          : l10n.formatText('hotels.searchResults.error.text');
      const errorCta = isError ? l10n.formatText('hotels.searchResults.error.cta') : '';

      return (
        <UitkSpacing padding={{ blockend: 'twelve' }}>
          <div className="uitk-type-center" data-stid="empty-state-error">
            <UitkSpacing padding={{ blockstart: 'three' }}>
              <UitkEmptyState
                icon="error"
                heading={errorMessage}
                buttonText={errorCta}
                headingLevel="h2"
                onClick={() => this.handleRetry(':errorOnSearch', 'Try Again on error')}
                className="pwa-theme--grey-400"
              />
            </UitkSpacing>
          </div>
        </UitkSpacing>
      );
    }

    return null;
  }

  handleLinkActionFromErrorMessage = linkAction => {
    if (linkAction) {
      const { analytics } = this.props;
      const { referrerId } = linkAction.analytics;
      const message = 'MultiItem Error';
      const hotelsSearchURL = linkAction.resource && linkAction.resource.relativePath;

      if (referrerId && analytics && typeof analytics.trackEvent === 'function') {
        analytics.trackEvent(referrerId, message, null, null, true);
      }

      window.location.replace(hotelsSearchURL);
    } else {
      this.handleRetry(':errorOnSearch', 'MultiItem Retry Search');
    }
  };
}

const LargeSearchResults = ({ analytics, jsEnabled, results, showTools }) => (
  <UitkLayoutGrid columns={4} space="six">
    <UitkLayoutGridItem>
      <div>
        <Sidebar isActive={jsEnabled} />
      </div>
    </UitkLayoutGridItem>
    <UitkLayoutGridItem colSpan={3}>
      <div>
        {showTools && <ErrorBoundaryWrappedTools analytics={analytics} />}
        {results}
      </div>
    </UitkLayoutGridItem>
  </UitkLayoutGrid>
);

const ExtraLargeSearchResults = ({ analytics, jsEnabled, results, showTools }) => (
  <UitkLayoutGrid columns={4} space="six">
    <UitkLayoutGridItem>
      <div>
        <Sidebar isActive={jsEnabled} />
      </div>
    </UitkLayoutGridItem>
    <UitkLayoutGridItem colSpan={3}>
      <div>
        {showTools && <ErrorBoundaryWrappedTools analytics={analytics} />}
        {results}
      </div>
    </UitkLayoutGridItem>
  </UitkLayoutGrid>
);

const ErrorBoundaryWrappedTools = ({ analytics }) => (
  <ErrorBoundary label="hotel.search.tools">
    <ResultsHeader analytics={analytics} />
  </ErrorBoundary>
);

module.exports = Search;
